import _ from "lodash";
import logger from "../utils/LoggerFrontend";
import Reflux from "reflux";

import Actions from "../Actions";

// eslint-disable-next-line import/no-unresolved
import { CustomerSucessController } from "@talentbait/shared-components";
import { getChatbotMessage } from "../data/app__chatbotMessages";

import { v4 as uuidv4 } from "uuid";
import { t } from "i18next";

// Orgas that don't use the template message feature
/** @todo No orgas anymore. Remove related code in another PR */
const TEMPLATE_MESSAGE_FEATURE_FLAG = [];

const defaultQuestions = ({ lng }) => [
  {
    question: t("Haben Sie Erfahrung in diesem Bereich?", { lng }),
    key: "Berufserfahrung",
    formality: "Sie",
    source: "default",
    selections: [
      {
        text: t("Yes", { lng }),
        isDisqualifying: false
      },
      {
        text: t("No", { lng }),
        isDisqualifying: false
      }
    ]
  },
  {
    question: t("Welchen Abschluss haben Sie?", { lng }),
    key: "Abschluss",
    selections: [],
    formality: "Sie",
    source: "default"
  },
  {
    question: t("Hast Du Erfahrung in diesem Bereich?", { lng }),
    key: "Berufserfahrung",
    formality: "Du",
    source: "default",
    selections: [
      {
        text: t("Yes", { lng }),
        isDisqualifying: false
      },
      {
        text: t("No", { lng }),
        isDisqualifying: false
      }
    ]
  },
  {
    question: t("Welchen Abschluss hast Du?", { lng }),
    key: "Abschluss",
    formality: "Du",
    source: "default",
    selections: []
  }
];

const defaultFormality = "Du";

const getDefaultState = ({ lng }) => {
  const questions = defaultQuestions({ lng })
    .filter((q) => q.formality === defaultFormality)
    .map((q) => ({ ...q, id: uuidv4() }));

  return {
    // Main ATS Config fields
    formality: defaultFormality,
    questions,
    selectedChatbotQuestion: null,
    // Suggestions
    historicalQuestions: [],
    allChatbotQuestions: getChatbotMessage(),
    hasNewQuestion: false,
    hasFetchedHistoricalData: false,
    hasFetchedATSOrgaSettings: false,
    hasFetchedAtsDataForCampaign: false
  };
};

export const replaceDefaultQuestionsWithNewFormalityAndLanguage = (questions, formality, lng) => {
  return questions.map((question) => {
    let finalQuestion = question;
    if (question.source == "default") {
      const similarDefaultQuestion = _.filter(defaultQuestions({ lng }), {
        key: question.key,
        formality
      })[0];
      finalQuestion = similarDefaultQuestion
        ? { ...similarDefaultQuestion, id: uuidv4() }
        : question;
    }
    return finalQuestion;
  });
};

export default class QualificationQuestionsStore extends Reflux.Store {
  constructor(props) {
    super(props);
    const lng = navigator?.language || "de";
    this.state = Object.assign({}, getDefaultState({ lng }));

    this.listenables = Actions;
  }

  replaceFollowupQuestion(formality, campaignLanguage) {
    // Replace the currently selected chatbot question to a similar one but in
    // the new formality version
    let { selectedChatbotQuestion, allChatbotQuestions = [] } = this.state;

    const selectedChatbotQuestionObject = allChatbotQuestions.find(
      ({ id }) => id === selectedChatbotQuestion
    );

    logger.debug("QualificationQuestionsStore:replaceChatbotQuestion", "called", {
      formality,
      selectedChatbotQuestion,
      allChatbotQuestions,
      selectedChatbotQuestionObject
    });
    const isFormal = formality === "Sie";
    const { variantGroupId = "" } = selectedChatbotQuestionObject || {};
    let possibleReplacements = allChatbotQuestions.filter(
      (q) =>
        q.isFormal === isFormal &&
        variantGroupId === q.variantGroupId &&
        q.language === campaignLanguage
    );

    if (possibleReplacements.length && possibleReplacements[0] && possibleReplacements[0].text) {
      logger.log(
        "QualificationQuestionsStore:replaceChatbotQuestion",
        "automatically changing selected chatbot question",
        {
          oldChatbotQuestion: selectedChatbotQuestion,
          newChatbotQuestion: possibleReplacements[0].text
        }
      );
      selectedChatbotQuestion = possibleReplacements[0].id;
      this.setState({
        selectedChatbotQuestion
      });
    }
  }

  replaceChatbotQuestion(formality) {
    // Replace the currently selected chatbot question to a similar one but in
    // the new formality version
    let { selectedChatbotQuestion, allChatbotQuestions = [] } = this.state;

    const selectedChatbotQuestionObject = allChatbotQuestions.find(
      ({ text }) => text === selectedChatbotQuestion
    );

    logger.debug("QualificationQuestionsStore:replaceChatbotQuestion", "called", {
      formality,
      selectedChatbotQuestion,
      allChatbotQuestions,
      selectedChatbotQuestionObject
    });
    const isFormal = formality == "Sie" ? true : false;
    const { systemName = "" } = selectedChatbotQuestionObject || {};
    let possibleReplacements = _.filter(allChatbotQuestions, {
      isFormal,
      systemName
    });
    if (possibleReplacements.length && possibleReplacements[0] && possibleReplacements[0].text) {
      logger.log(
        "QualificationQuestionsStore:replaceChatbotQuestion",
        "automatically changing selected chatbot question",
        {
          oldChatbotQuestion: selectedChatbotQuestion,
          newChatbotQuestion: possibleReplacements[0].text
        }
      );
      selectedChatbotQuestion = possibleReplacements[0].text;
      this.setState({
        selectedChatbotQuestion
      });
    }
  }

  replaceDefaultQuestions(formality, lng) {
    // Replace all the default questions currently shown to the new version
    // based on the new formality
    let { questions = [] } = this.state;
    questions = replaceDefaultQuestionsWithNewFormalityAndLanguage(questions, formality, lng);
    this.setState({
      questions
    });
  }

  onGetAtsTemplatesByTypeCompleted(templates, type) {
    logger.debug("QualificationQuestionsStore:onGetAtsTemplatesByTypeCompleted", "called", {
      templates,
      type
    });
    if (templates && templates.length) {
      this.setState({
        allChatbotQuestions: templates
      });
    }
  }

  onGetFollowupQuestionTemplatesCompleted(templates, orgaId) {
    logger.debug("QualificationQuestionsStore:onGetFollowupQuestionTemplatesCompleted", "called", {
      templates,
      orgaId
    });
    if (templates && templates.length) {
      this.setState({
        allChatbotQuestions: templates
      });
    }
  }

  onGetAtsOrgaCompleted(atsOrga, lng) {
    logger.log("QualificationQuestionsStore:onGetAtsOrgaCompleted", "finished", {
      atsOrga,
      lng
    });
    let { formality = defaultFormality, firstChatbotQuestion } = atsOrga;
    this.replaceDefaultQuestions(formality, lng);
    this.setState({
      formality,
      selectedChatbotQuestion: firstChatbotQuestion || this.state.selectedChatbotQuestion,
      hasFetchedATSOrgaSettings: true
    });
    logger.log(
      "QualificationQuestionsStore:onGetAtsOrgaCompleted",
      "loaded orga level ats settings",
      {
        formality,
        firstChatbotQuestion
      }
    );
  }

  // All Previous ATS data handeler
  onGetAllAtsForOrgaCompleted(atsObjects) {
    logger.debug("QualificationQuestionsStore:onGetAllAtsForOrgaCompleted", "finished", {
      atsObjects
    });
    let previousQuestions = atsObjects.map(({ config }) => config.formQuestions).flat();
    previousQuestions = _.orderBy(previousQuestions, "createdDate", "desc");
    previousQuestions = previousQuestions.map((q) => {
      const { question = "", selections, key, isFormal } = q;
      return {
        question: question.trim(),
        selections,
        key,
        isFormal,
        source: "historic"
      };
    });
    previousQuestions = _.uniqBy(previousQuestions, "question");
    previousQuestions = previousQuestions.map((q) => ({ ...q, id: uuidv4() }));

    logger.log(
      "QualificationQuestionsStore:onGetAllAtsForOrgaCompleted",
      "found previously used questions",
      {
        previousQuestions: previousQuestions.length
      }
    );
    this.setState({
      historicalQuestions: previousQuestions,
      hasFetchedHistoricalData: true
    });
  }

  // Existing ATS data handler
  onGetAtsDataCompleted(atsDoc) {
    if (!atsDoc?.data) {
      return;
    }
    const atsData = atsDoc.data();
    logger.log("QualificationQuestionsStore:onGetAtsDataCompleted", "called", {
      atsData,
      atsDoc,
      state: this.state
    });

    const { config } = atsData;
    if (!config) {
      logger.log(
        "error:QualificationQuestionsStore:onGetAtsDataCompleted",
        "no config on saved ats data",
        { atsData }
      );
      return;
    }

    let { formQuestions: questions, firstChatbotQuestion, isFormal, applicationEmail } = config;

    const formality = isFormal ? "Sie" : "Du";

    if (!questions) {
      questions = [];
    }

    this.setState({
      questions,
      selectedChatbotQuestion: firstChatbotQuestion || this.state.selectedChatbotQuestion,
      formality,
      applicationEmail,
      hasFetchedAtsDataForCampaign: true
    });
  }

  onUpdateQualificationQuestion(questions, hasNewQuestion = false) {
    logger.log("QualificationQuestionsStore:onUpdateQualificationQuestion", "called", {
      questions,
      hasNewQuestion
    });
    this.setState({
      questions,
      hasNewQuestion
    });
  }

  onUpdateATSFormality(formality, orgaId, campaignLanguage) {
    logger.log("QualificationQuestionsStore:onUpdateATSFormality", "called", {
      formality,
      orgaId,
      campaignLanguage
    });
    CustomerSucessController.send("QualificationQuestions:changedFormality", {
      formality
    });
    this.replaceDefaultQuestions(formality, campaignLanguage);

    if (!TEMPLATE_MESSAGE_FEATURE_FLAG.includes(orgaId)) {
      this.replaceFollowupQuestion(formality, campaignLanguage);
    } else {
      this.replaceChatbotQuestion(formality);
    }
    this.setState({
      formality
    });
  }

  onUpdateChatbotQuestion(selectedChatbotQuestion) {
    logger.debug("QualificationQuestionsStore:onUpdateChatbotQuestion", "called", {
      selectedChatbotQuestion
    });
    this.setState({
      selectedChatbotQuestion: selectedChatbotQuestion
    });
  }

  onCampaignCreateResetData(lng) {
    const newState = Object.assign({}, getDefaultState({ lng }));
    logger.log("QualificationQuestionsStore:onCampaignCreateResetData", "called...", { newState });
    this.setState(newState);
  }

  onResetQualificationQuestions(lng) {
    const newState = Object.assign({}, getDefaultState({ lng }));
    logger.log("QualificationQuestionsStore:onResetQualificationQuestions", "called...");
    this.setState(newState);
  }
}
